import React, { FC, useContext } from "react";

import { AttributeHandBook } from "./AttributeHandBook";
import { FeatureCardContext } from "../../FeatureCardHeader/FeatureCardContext";
import { FeatureAttribute } from "../FeatureAttributeField";
import { ConfigContainerChild } from "../../../types";

export const HandbookAttributeValue: FC<{
  attribute: FeatureAttribute;
  element: ConfigContainerChild;
}> = ({ attribute }) => {
  const { layerInfo, setHandBookReference } = useContext(FeatureCardContext);

  return (
    <AttributeHandBook
      key={attribute.name}
      layer={layerInfo}
      attribute={attribute}
      setHandBookReference={setHandBookReference}
      showLabel={false}
    />
  );
};
